import React, { useEffect } from "react";
import StartBtn from "../StartBtn";

function Hero() {
  useEffect(() => {
    document.title = "Centerio - Home";
  }, []);

  return (
    <>
      <div className="bg-white">
        <div className="mx-auto max-w-screen-2xl px-4 pt-8 md:px-8">
          <section className="flex flex-col justify-between gap-12 sm:gap-10 md:gap-16 lg:flex-row">
            <div className="flex flex-col justify-between xl:w-5/12">
              <div className="sm:text-center lg:py-12 lg:text-left xl:py-24">
                <p className="mb-4 font-semibold text-indigo-500 md:mb-6 md:text-lg xl:text-xl">
                  Welcome Back !!
                </p>

                <h1 className="text-black-800 mb-8 text-4xl font-bold sm:text-5xl md:mb-12 md:text-6xl">
                  Keep A Digital Record of Your Piggy Bank In Web
                </h1>

                <div className="flex flex-col gap-2.5 sm:flex-row sm:justify-center lg:justify-start">
                  <StartBtn />
                </div>
              </div>
            </div>

            <div className="h-80 overflow-hidden rounded-lg bg-gray-100 shadow-lg lg:h-auto xl:w-5/12">
              <img
                src="https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?auto=format&q=75&fit=crop&w=1000"
                loading="lazy"
                alt="By Fakurian Design"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Hero;
